import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, Input, HostListener } from '@angular/core';
import { consumeEvent } from '@eui/core';

@Component({
    selector: 'eui-notifications',
    templateUrl: './eui-notifications.component.html',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiNotificationsComponent {

    @HostBinding('class') string = 'eui-notifications';

    @Input() count: number = null;
    @Input() items = [];

    isOverlayActive = false;

    constructor() {
    }

    @HostListener('body:click')
    closeProfileDropdown() {
        this.isOverlayActive = false;
    }

    onClicked(event: any) {
        consumeEvent(event);
        this.isOverlayActive = !this.isOverlayActive;
    }
}
